/* tslint:disable */
/* eslint-disable */
/**
 * EXPItec API
 * The EXPItec API provides an interface to the EXPInet Reisesuche Frontend 
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Description of a deck.
 * @export
 * @interface Deck
 */
export interface Deck {
    /**
     * The deck number.
     * @type {number}
     * @memberof Deck
     */
    deck?: number;
    /**
     * Image url of the deck.
     * @type {string}
     * @memberof Deck
     */
    imageUrl?: string;
}

/**
 * Check if a given object implements the Deck interface.
 */
export function instanceOfDeck(value: object): value is Deck {
    return true;
}

export function DeckFromJSON(json: any): Deck {
    return DeckFromJSONTyped(json, false);
}

export function DeckFromJSONTyped(json: any, ignoreDiscriminator: boolean): Deck {
    if (json == null) {
        return json;
    }
    return {
        
        'deck': json['deck'] == null ? undefined : json['deck'],
        'imageUrl': json['imageUrl'] == null ? undefined : json['imageUrl'],
    };
}

export function DeckToJSON(json: any): Deck {
    return DeckToJSONTyped(json, false);
}

export function DeckToJSONTyped(value?: Deck | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'deck': value['deck'],
        'imageUrl': value['imageUrl'],
    };
}

